const COVER_MAX = 4;

export function composeCoverThumbs(items: Array<{ thumb?: string }>): string[] {
  const out: string[] = [];
  const seen = new Set<string>();
  for (const item of items) {
    const thumb = item.thumb?.trim() ?? '';
    if (!thumb || seen.has(thumb)) continue;
    seen.add(thumb);
    out.push(thumb);
    if (out.length >= COVER_MAX) break;
  }
  return out;
}
